import { GlobalAction, BillingState } from '.';

const GET_BILLING_OVERVIEWS_START = 'GET_BILLING_OVERVIEWS_START';
const GET_BILLING_OVERVIEWS_ERROR = 'GET_BILLING_OVERVIEWS_ERROR';
const GET_BILLING_OVERVIEWS_SUCCESS = 'GET_BILLING_OVERVIEWS_SUCCESS';
const GET_BILLING_OVERVIEW_START = 'GET_BILLING_OVERVIEW_START';
const GET_BILLING_OVERVIEW_ERROR = 'GET_BILLING_OVERVIEW_ERROR';
const GET_BILLING_OVERVIEW_SUCCESS = 'GET_BILLING_OVERVIEW_SUCCESS';

const GET_BILLING_INVOICES_START = 'GET_BILLING_INVOICES_START';
const GET_BILLING_INVOICES_ERROR = 'GET_BILLING_INVOICES_ERROR';
const GET_BILLING_INVOICES_SUCCESS = 'GET_BILLING_INVOICES_SUCCESS';
const GET_BILLING_INVOICE_START = 'GET_BILLING_INVOICE_START';
const GET_BILLING_INVOICE_ERROR = 'GET_BILLING_INVOICE_ERROR';
const GET_BILLING_INVOICE_SUCCESS = 'GET_BILLING_INVOICE_SUCCESS';

const GET_BILLING_CARDS_START = 'GET_BILLING_CARDS_START';
const GET_BILLING_CARDS_ERROR = 'GET_BILLING_CARDS_ERROR';
const GET_BILLING_CARDS_SUCCESS = 'GET_BILLING_CARDS_SUCCESS';

export const billingReducer = (
  state: BillingState,
  action: GlobalAction
): BillingState => {
  const { payload, type } = action;
  switch (type) {
    case GET_BILLING_OVERVIEWS_START:
    case GET_BILLING_OVERVIEW_START: {
      return {
        ...state,
        subscription: {
          ...state.subscription,
          loading: true,
        },
      };
    }
    case GET_BILLING_OVERVIEWS_ERROR: {
      return {
        ...state,
        subscription: {
          ...state.subscription,
          loading: false,
        },
      };
    }
    case GET_BILLING_OVERVIEWS_SUCCESS: {
      return {
        ...state,
        subscription: {
          card: payload.subscription.card,
          plan: payload.subscription.plan || {},
          upcomingInvoice: payload.subscription.upcomingInvoice,
          loading: false,
          totalActiveUsers: payload.subscription.totalActiveUsers || 0,
          totalAllowedUsers: payload.subscription.totalAllowedUsers || 0,
          addons: payload.subscription.addons || [],
          cancelAt: payload.subscription.cancelAt || null,
          currentPeriodEnd: payload.subscription.currentPeriodEnd || null,
          nextPeriodStart: payload.subscription.nextPeriodStart || null,
        },
      };
    }
    case GET_BILLING_INVOICES_START:
    case GET_BILLING_INVOICE_START: {
      return {
        ...state,
        invoices: {
          ...state.invoices,
          loading: true,
        },
      };
    }
    case GET_BILLING_INVOICES_ERROR: {
      return {
        ...state,
        invoices: {
          ...state.invoices,
          loading: false,
        },
      };
    }
    case GET_BILLING_INVOICES_SUCCESS: {
      return {
        ...state,
        invoices: {
          items: [...payload.invoices.items],
          hasMore: payload.hasMore,
          loading: false,
        },
      };
    }
    case GET_BILLING_CARDS_START: {
      return {
        ...state,
        cards: {
          ...state.cards,
          loading: true,
        },
      };
    }
    case GET_BILLING_CARDS_ERROR: {
      return {
        ...state,
        cards: {
          ...state.cards,
          loading: false,
        },
      };
    }
    case GET_BILLING_CARDS_SUCCESS: {
      return {
        ...state,
        cards: {
          items: [...payload.cards.items],
          hasMore: payload.hasMore,
          loading: false,
        },
      };
    }
    default:
      return state;
  }
};

export const BILLING_ACTIONS = {
  GET_BILLING_OVERVIEWS_START,
  GET_BILLING_OVERVIEWS_ERROR,
  GET_BILLING_OVERVIEWS_SUCCESS,
  GET_BILLING_OVERVIEW_START,
  GET_BILLING_OVERVIEW_ERROR,
  GET_BILLING_OVERVIEW_SUCCESS,
  GET_BILLING_INVOICES_START,
  GET_BILLING_INVOICES_ERROR,
  GET_BILLING_INVOICES_SUCCESS,
  GET_BILLING_INVOICE_START,
  GET_BILLING_INVOICE_ERROR,
  GET_BILLING_INVOICE_SUCCESS,
  GET_BILLING_CARDS_START,
  GET_BILLING_CARDS_ERROR,
  GET_BILLING_CARDS_SUCCESS,
};
